"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_ORGANIZATIONAL_ROLE_TO_DEFAULT_FIELDS = exports.USER_USE_CASES_DEFINITIONS = exports.USER_RESPONSIBILITY_DEFINITIONS = void 0;
var types_1 = require("../customers/types");
var types_2 = require("../departments/types");
var types_3 = require("./types");
exports.USER_RESPONSIBILITY_DEFINITIONS = [
    {
        responsibility: types_3.UserResponsibilities.POLICY,
        displayName: { en: 'Deciding on policies', he: 'קביעת מדיניות' },
    },
    {
        responsibility: types_3.UserResponsibilities.BUDGET_SPENDING,
        displayName: {
            en: 'Steering, executing & tracking budget and spending',
            he: 'ניהול תקציבי: היגוי, ביצוע ומעקב אחר הוצאות',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.COUNCIL_MEETINGS,
        displayName: { en: 'Preparing for council meetings', he: 'הכנות לישיבות מועצה' },
    },
    {
        responsibility: types_3.UserResponsibilities.MEETINGS_WITH_MANAGEMENT,
        displayName: {
            en: 'Meeting/updating preparations with management',
            he: 'הכנת פגישות ועדכונים להנהלה',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.STRATEGIC_PROJECTS,
        displayName: {
            en: 'Running & tracking strategic projects',
            he: 'ניהול ומעקב אחר פרויקטים אסטרטגיים',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.MEDIA_MONITORING,
        displayName: { en: 'Monitoring social & traditional media', he: 'ניטור מדיה חברתית ומסורתית' },
    },
    {
        responsibility: types_3.UserResponsibilities.MESSAGES_CAMPAIGNS,
        displayName: {
            en: 'Crafting/creating messages and campaigns',
            he: 'הגדרת מסרים והובלת מסעות פרסום (קמפיינים)',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.ANALYSIS_REPORTS_FOR_MANAGEMENT,
        displayName: {
            en: 'Creating in-depth analysis reports for management',
            he: 'הכנת דוחות וניתוח נתונים ניהוליים',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.CITIZEN_PARTICIPATION,
        displayName: {
            en: 'Organizing citizen participation activities',
            he: 'ארגון פעילויות ואירועים בהשתתפות התושבים',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.CONTACT_CITIZENS,
        displayName: {
            en: 'Contacting citizens and working with the public to determine desired services',
            he: 'קשר עם התושבים ושיתוף הציבור בקביעת השירותים הרצויים',
        },
    },
    {
        responsibility: types_3.UserResponsibilities.LEGISLATIVE,
        displayName: { en: 'Legislative', he: 'חקיקה' },
    },
    {
        responsibility: types_3.UserResponsibilities.ELECTED_OFFICIAL,
        displayName: { en: 'I am an elected official', he: 'אני נבחר/ת ציבור' },
    },
    {
        responsibility: types_3.UserResponsibilities.OTHER,
        displayName: { en: 'Other', he: 'אחר' },
    },
];
exports.USER_USE_CASES_DEFINITIONS = [
    {
        useCase: types_3.UserUseCases.TOP_POLICY_MAKER,
        conditions: [
            {
                customerType: types_1.CustomerTypes.CITY,
                governmentType: types_1.GovernmentTypes.MAYOR_COUNCIL,
                organizationalRole: [types_3.OrganizationalRoles.MAYOR],
            },
            {
                customerType: types_1.CustomerTypes.CITY,
                organizationalRole: [types_3.OrganizationalRoles.CITY_MANAGER],
            },
            {
                customerType: types_1.CustomerTypes.COUNTY,
                organizationalRole: [
                    types_3.OrganizationalRoles.COUNTY_EXECUTIVE,
                    types_3.OrganizationalRoles.COUNTY_MANAGER,
                    types_3.OrganizationalRoles.COUNTY_MAYOR,
                    types_3.OrganizationalRoles.COUNTY_ADMINISTRATOR,
                ],
            },
            {
                customerType: types_1.CustomerTypes.LAW_ENFORCEMENT_AGENCY,
                organizationalRole: [types_3.OrganizationalRoles.SHERIFF, types_3.OrganizationalRoles.POLICE_CHIEF],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.MANAGEMENT,
        conditions: [
            {
                departmentPosition: types_3.UserDepartmentPositions.HEAD,
            },
            { responsibilities: [types_3.UserResponsibilities.STRATEGIC_PROJECTS] },
        ],
    },
    {
        useCase: types_3.UserUseCases.COMMUNICATION,
        conditions: [
            {
                departmentResponsibilities: [types_2.DepartmentResponsibilities.COMMUNICATIONS],
            },
            {
                responsibilities: [types_3.UserResponsibilities.MESSAGES_CAMPAIGNS],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.ANALYST_RESEARCHER,
        displayName: { en: 'Analyst / Researcher' },
        conditions: [
            {
                responsibilities: [types_3.UserResponsibilities.ANALYSIS_REPORTS_FOR_MANAGEMENT],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.COMMUNITY_ENGAGEMENT,
        displayName: { en: 'Community Engagement Coordinator' },
        conditions: [
            {
                responsibilities: [
                    types_3.UserResponsibilities.CITIZEN_PARTICIPATION,
                    types_3.UserResponsibilities.CONTACT_CITIZENS,
                ],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.ELECTED_OFFICIAL,
        conditions: [
            {
                customerType: types_1.CustomerTypes.CITY,
                organizationalRole: [types_3.OrganizationalRoles.COUNCIL_MEMBER],
            },
            {
                customerType: types_1.CustomerTypes.CITY,
                governmentType: types_1.GovernmentTypes.COUNCIL_MANAGER,
                departmentType: [types_2.PredefinedDepartmentTypes.MAYOR_OFFICE],
            },
            {
                customerType: types_1.CustomerTypes.COUNTY,
                organizationalRole: [types_3.OrganizationalRoles.COUNCIL_MEMBER],
            },
            {
                responsibilities: [types_3.UserResponsibilities.ELECTED_OFFICIAL],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.HEAD_OF_PROGRAM,
        conditions: [
            {
                organizationalRole: [types_3.OrganizationalRoles.HEAD_OF_PROGRAM],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.PROGRAM_COORDINATOR,
        conditions: [
            {
                organizationalRole: [types_3.OrganizationalRoles.PROGRAM_COORDINATOR],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.PROGRAM_MANAGER_OFFICER,
        displayName: { en: 'Program Manager / Officer' },
        conditions: [
            {
                organizationalRole: [types_3.OrganizationalRoles.PROGRAM_MANAGER_OFFICER],
            },
        ],
    },
    {
        useCase: types_3.UserUseCases.EXECUTIVE_ASSISTANT,
        conditions: [
            {
                organizationalRole: [types_3.OrganizationalRoles.EXECUTIVE_ASSISTANT],
            },
        ],
    },
];
exports.CUSTOMER_ORGANIZATIONAL_ROLE_TO_DEFAULT_FIELDS = (_a = {},
    _a[types_1.CustomerTypes.CITY] = (_b = {},
        _b[types_3.OrganizationalRoles.MAYOR] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.MAYOR_OFFICE,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.COUNCIL_MEETINGS,
                types_3.UserResponsibilities.LEGISLATIVE,
                types_3.UserResponsibilities.ELECTED_OFFICIAL,
            ],
            isPredefined: true,
        },
        _b[types_3.OrganizationalRoles.CITY_MANAGER] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.CITY_MANAGER_OFFICE,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.COUNCIL_MEETINGS,
            ],
            isPredefined: true,
        },
        _b[types_3.OrganizationalRoles.ASSISTANT_CITY_MANAGER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            departmentType: types_2.PredefinedDepartmentTypes.CITY_MANAGER_OFFICE,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.DEPUTY_HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.DEPUTY_HEAD,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.HEAD_OF_PROGRAM] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.PROGRAM_COORDINATOR] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.PROGRAM_MANAGER_OFFICER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.EXTERNAL_CONSULTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.CONSULTANT,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.EXECUTIVE_ASSISTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.COUNCIL_MEMBER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            departmentType: types_2.PredefinedDepartmentTypes.CITY_COUNCIL,
            responsibilities: [types_3.UserResponsibilities.LEGISLATIVE, types_3.UserResponsibilities.POLICY],
            isPredefined: true,
        },
        _b[types_3.OrganizationalRoles.TEAM_MEMBER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _b[types_3.OrganizationalRoles.OTHER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _b),
    _a[types_1.CustomerTypes.COUNTY] = (_c = {},
        _c[types_3.OrganizationalRoles.COUNTY_ADMINISTRATOR] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.COUNTY_ADMIN_MAYOR,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.COUNCIL_MEETINGS,
                types_3.UserResponsibilities.LEGISLATIVE,
            ],
            isPredefined: true,
        },
        _c[types_3.OrganizationalRoles.COUNTY_EXECUTIVE] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.COUNTY_ADMIN_MAYOR,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.COUNCIL_MEETINGS,
                types_3.UserResponsibilities.LEGISLATIVE,
            ],
            isPredefined: true,
        },
        _c[types_3.OrganizationalRoles.COUNTY_MANAGER] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.COUNTY_ADMIN_MAYOR,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.COUNCIL_MEETINGS,
                types_3.UserResponsibilities.LEGISLATIVE,
            ],
            isPredefined: true,
        },
        _c[types_3.OrganizationalRoles.COUNTY_MAYOR] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.COUNTY_ADMIN_MAYOR,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.COUNCIL_MEETINGS,
                types_3.UserResponsibilities.LEGISLATIVE,
            ],
            isPredefined: true,
        },
        _c[types_3.OrganizationalRoles.DEPUTY_COUNTY_ADMINISTRATOR] = {
            departmentPosition: types_3.UserDepartmentPositions.DEPUTY_HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.COUNTY_ADMIN_MAYOR,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.DEPUTY_HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.DEPUTY_HEAD,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.HEAD_OF_PROGRAM] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.PROGRAM_COORDINATOR] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.PROGRAM_MANAGER_OFFICER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.EXTERNAL_CONSULTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.CONSULTANT,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.EXECUTIVE_ASSISTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.COUNCIL_MEMBER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            departmentType: types_2.PredefinedDepartmentTypes.COUNTY_COUNCIL,
            responsibilities: [types_3.UserResponsibilities.LEGISLATIVE, types_3.UserResponsibilities.POLICY],
            isPredefined: true,
        },
        _c[types_3.OrganizationalRoles.TEAM_MEMBER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _c[types_3.OrganizationalRoles.OTHER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _c),
    _a[types_1.CustomerTypes.LAW_ENFORCEMENT_AGENCY] = (_d = {},
        _d[types_3.OrganizationalRoles.SHERIFF] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.CHIEF_ADMINISTRATION,
            responsibilities: [
                types_3.UserResponsibilities.POLICY,
                types_3.UserResponsibilities.BUDGET_SPENDING,
                types_3.UserResponsibilities.ELECTED_OFFICIAL,
            ],
            isPredefined: true,
        },
        _d[types_3.OrganizationalRoles.POLICE_CHIEF] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            departmentType: types_2.PredefinedDepartmentTypes.CHIEF_ADMINISTRATION,
            responsibilities: [types_3.UserResponsibilities.POLICY, types_3.UserResponsibilities.BUDGET_SPENDING],
            isPredefined: true,
        },
        _d[types_3.OrganizationalRoles.HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.DEPUTY_HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.DEPUTY_HEAD,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.HEAD_OF_PROGRAM] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.PROGRAM_COORDINATOR] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.PROGRAM_MANAGER_OFFICER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.EXTERNAL_CONSULTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.CONSULTANT,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.EXECUTIVE_ASSISTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.PATROL_FIELD_OFFICER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.TEAM_MEMBER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d[types_3.OrganizationalRoles.OTHER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _d),
    _a[types_1.CustomerTypes.STATE_AGENCY] = (_e = {},
        _e[types_3.OrganizationalRoles.HEAD_OF_STATE_AGENCY] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.DIRECTOR] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.HEAD,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.DEPUTY_HEAD_OF_DEPARTMENT] = {
            departmentPosition: types_3.UserDepartmentPositions.DEPUTY_HEAD,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.HEAD_OF_PROGRAM] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.PROGRAM_COORDINATOR] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.PROGRAM_MANAGER_OFFICER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.EXTERNAL_CONSULTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.CONSULTANT,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.EXECUTIVE_ASSISTANT] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.TEAM_MEMBER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _e[types_3.OrganizationalRoles.OTHER] = {
            departmentPosition: types_3.UserDepartmentPositions.TEAM_MEMBER,
            isPredefined: false,
        },
        _e),
    _a[types_1.CustomerTypes.OTHER] = {},
    _a);
